import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { getCustomers, type CustomersResponse, type GetCustomersParams } from './api';

export type GetCustomersInfiniteParams = Omit<GetCustomersParams, 'page'>;

export function useCustomerByIdQuery(customerId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['customer', customerId],
    queryFn: () =>
      getCustomers({
        page: 1,
        limit: 1,
        customerId,
      }),
    enabled: enabled && Boolean(customerId),
    staleTime: 30 * 1000,
    select: (res) => res.data[0] ?? null,
  });
}

export function useCustomersInfiniteQuery(params: GetCustomersInfiniteParams) {
  return useInfiniteQuery<CustomersResponse>({
    queryKey: ['customers', params],
    queryFn: ({ pageParam }) => getCustomers({ ...params, page: pageParam as number }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.hasNextPage ? allPages.length + 1 : undefined,
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}
